// utils/droneNestUtils.js

/**
 * Checks whether a point (x, y) lies inside a box centered at (bx, by).
 */
export const isInsideBox = (x, y, bx, by, size) => {
  return (
    Number(x) >= Number(bx) - Number(size) / 2 &&
    Number(x) <= Number(bx) + Number(size) / 2 &&
    Number(y) >= Number(by) - Number(size) / 2 &&
    Number(y) <= Number(by) + Number(size) / 2
  );
};

export const generateUniqueId = (length = 10) => {
  const lowercase = "abcdefghijklmnopqrstuvwxyz";
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const digits = "0123456789";
  const symbols = "!@#$%^&*()_+[]{}|;:,.<>?";
  const all = lowercase + uppercase + digits;

  const getRandom = (chars) => chars[Math.floor(Math.random() * chars.length)];

  // Ensure one of each type
  const id = [
    getRandom(lowercase),
    getRandom(uppercase),
    getRandom(digits),
  ];

  for (let i = id.length; i < length; i++) {
    id.push(getRandom(all));
  }

  // Shuffle the characters
  return id.sort(() => Math.random() - 0.5).join("");
};
